import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    table: {
        marginBottom: '8px'
    },
    filterCell: {
        width: '170px',
        backgroundColor: '#eeeeee',
        border: '1px solid #fff',
        padding: '10px',

    },
    filterLabel: {
        fontSize: '14px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        lineHeight: '34px'
    },
    valueCell: {
        backgroundColor: '#dddddd',
        border: '1px solid #fff',
        padding: '10px',
        fontSize: '15px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    filterMenuPaper: {
        boxSizing: 'border-box',
        position: 'absolute',
        width: '400px',
        overflowWrap: 'anywhere',
        height: 'auto',
        zIndex: 100,
    },
    footer: {
        backgroundColor: '#e0e0e0',
        height: '50px'
    },
    applyButton: {
        flexBasis: '50%',
        boxShadow: 'none',
        borderRadius: 0,
        float: 'right',
        lineHeight: '34px',
        padding: '8px 16px'
    },
    fieldsContainer: {
        padding: '15px'
    }
});
